
import { FaUserFriends, FaRegPaperPlane, FaRegCalendarAlt } from "react-icons/fa";
import { useGetReferralsData } from "../../queries/dashboard";
import Section from "./Section";

const ReferralCard = ({ title, value, icon, color = "primary" }) => (
    <div className={`bg-white shadow border border-chipMagenta rounded-lg p-5 flex-1 min-w-[200px] ${color} flex flex-col gap-3 justify-between`}>
        <div className='flex items-center justify-between'>
            <h3 className={`text-base font-extrabold text-${color}`}>{title}</h3>
            {icon && <span className={`text-2xl text-${color}`}>{icon}</span>}
        </div>
        <div className={`text-2xl font-bold text-${color}`}>{value}</div>
    </div>
);

const Referrals = () => {
    const { data: referralData, isPending: isReferralDataPending } = useGetReferralsData();

    const stats = {
        challengeInvites: referralData?.challengeInvites || 0,
        eventInvites: referralData?.eventInvites || 0,
        appInvites: referralData?.appInvites || 0,
    };

    return (
        <Section
            title={"Referrals"}
            isLoading={isReferralDataPending}
            gridCols={1}
            gridRows={3}
            theme="magenta"
        >
            <ReferralCard
                title="Challenge Referrals"
                value={stats.challengeInvites}
                icon={<FaRegPaperPlane />}
                color="chipMagenta"
            />
            <ReferralCard
                title="Event Referrals"
                value={stats.eventInvites}
                icon={<FaRegCalendarAlt />}
                color="chipMagenta"
            />
            <ReferralCard
                title="App Referrals"
                value={stats.appInvites}
                icon={<FaUserFriends />}
                color="chipMagenta"
            />
        </Section>
    );
};

export default Referrals;